// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "fbecc3be0794009d2a7ad010f47accab" + ".css";
};